export default __webpack_public_path__ + "static/media/Rich Table (4).66fac033.png";